module.exports = __webpack_public_path__ + "assets/images/7d92d4baab76fd6d80350b0d6fdc6327.png";